import type { CatalogRole, RouteInfo } from '../../../services/iam';

/** Routes whose required permission is in this role's flattened set; empty for every role until routes migrate. */
export function routesGrantedByRole(
    role: CatalogRole,
    routes: readonly RouteInfo[]
): readonly RouteInfo[] {
    const grantedPermissions = new Set(role.flattened.map((entry) => entry.permission));
    return routes.filter(
        (route) => route.permission != null && grantedPermissions.has(route.permission)
    );
}
